<template>
  <div class="hours-container section-container">
    <div class="hours-image-wrapper section-image">
      <div class="hours-image image-wrapper dp-9">
        <div class="image-bg"></div>
      </div>
    </div>
    <div class="hours-message section-message">
      <h2>Store Hours</h2>
      <p>
        We are open nearly every day of the year, with only a few exceptions
        (like Christmas Day).
      </p>
      <div class="hours-wrapper">
        <div class="hours-day">Mon - Sat</div>
        <div class="hours-times">5am - 4pm</div>
      </div>
      <div class="hours-wrapper">
        <div class="hours-day">Sun</div>
        <div class="hours-times">6am - 4pm</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hours",
  mounted() {}
};
</script>

<style lang="scss">
.hours-image .image-bg {
  background-image: url("~@/assets/images/eyes.jpg");
}

.hours-wrapper {
  width: 70%;
  display: flex;
  align-content: center;
  justify-content: space-between;
}
</style>
